<template>
  <div class="table_class">
    <el-table
      ref="tableRef"
      :header-cell-style="{ background: '#f8fafc', color: '#6b7589' }"
      :row-class-name="rowClassName"
      :max-height="500"
      border
      :data="tableData"
      style="width: 100%"
    >

      <el-table-column
        v-for="(item, index) in tableHeaderList"
        :key="index"
        :label="item.label"
        :min-width="item.width"
        :prop="item.prop"
        :show-overflow-tooltip="true"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'currentTicketCount'">
            <span :style="getHubCodeStyle(scope.$index)">{{ scope.row[item.prop] || '--' }}</span>
          </div>
          <div v-else-if="item.prop === 'hubLevel' && scope.row.hubLevel">
            <span class="tag_class" style="background: #f2f4f7">
              {{ hubLVFn(scope.row.hubLevel) }}
            </span>
          </div>
          <div v-else-if="item.prop === 'stockTurnoverDays' && scope.row.stockTurnoverDays">
            <span
              class="tag_class"
              :style="scope.$index === 0 ? {} : {
                background: scope.row.stockTurnoverDays <= 1 ? '#ecfdf3' : scope.row.stockTurnoverDays <= 2 ? '#fdf8ec' : scope.row.stockTurnoverDays <= 3 ? '#fffaeb' : '#fef3f2',
                color: scope.row.stockTurnoverDays <= 1 ? '#079455' : scope.row.stockTurnoverDays <= 2 ? '#dcca03' : scope.row.stockTurnoverDays <= 3 ? '#df771a' : '#d92d20'
              }"
            >
              {{ scope.row.stockTurnoverDays }}{{ $t('basicData.NumberOfDays') }}
            </span>
          </div>
          <div v-else-if="item.prop === 'avgInventoryHours' && scope.row.avgInventoryHours">
            <span
              class="tag_class"
              :style="scope.$index === 0 ? {} : {
                background: scope.row.avgInventoryHours <= 24 ? '#ecfdf3' : scope.row.avgInventoryHours <= 36 ? '#fdf8ec' : scope.row.avgInventoryHours <= 48 ? '#fffaeb' : '#fef3f2',
                color: scope.row.avgInventoryHours <= 24 ? '#079455' : scope.row.avgInventoryHours <= 36 ? '#dcca03' : scope.row.avgInventoryHours <= 48 ? '#df771a' : '#d92d20'
              }"
            >
              {{ scope.row.avgInventoryHours }}h
            </span>
          </div>
          <div v-else-if="item.prop === 'inventoryAgingRate' && scope.row.inventoryAgingRate">
            <span
              class="tag_class"
              :style="scope.$index === 0 ? {} : {
                background: scope.row.inventoryAgingRate <= 5 ? '#ecfdf3' : scope.row.inventoryAgingRate <= 10 ? '#fdf8ec' : scope.row.inventoryAgingRate <= 20 ? '#fffaeb' : '#fef3f2',
                color: scope.row.inventoryAgingRate <= 5 ? '#079455' : scope.row.inventoryAgingRate <= 10 ? '#dcca03' : scope.row.inventoryAgingRate <= 20 ? '#df771a' : '#d92d20'
              }"
            >
              {{ scope.row.inventoryAgingRate }}%
            </span>
          </div>
          <div v-else-if="item.prop === 'netIncreaseTicketCount' && scope.row.netIncreaseTicketCount != null">
            <span
              class="tag_class"
              :style="scope.$index === 0 ? {} : {
                background: scope.row.netIncreaseTicketCount < 0 ? '#ecfdf3' : scope.row.netIncreaseTicketCount === 0 ? '#f3f1ee' : scope.row.netIncreaseTicketCount > 0 ? '#fef3f2' : '',
                color: scope.row.netIncreaseTicketCount < 0 ? '#079455' : scope.row.netIncreaseTicketCount == 0 ? '#989898' : scope.row.netIncreaseTicketCount > 0 ? '#d92d20' : ''
              }"
            >
              {{ scope.row.netIncreaseTicketCount >= 0 ? '+' : '' }}{{ scope.row.netIncreaseTicketCount }}
            </span>
          </div>
          <div v-else>
            {{ scope.row[item.prop] || '--' }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { hubList } from './utils';
export default {
  props: {
    // 可以通过props接收外部数据
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableHeaderList: hubList,
      hubLVList: [
        { label: this.$t('collectionCenter.hubVal39'), value: 'lv1' },
        { label: this.$t('collectionCenter.hubVal40'), value: 'lv2' },
        { label: this.$t('collectionCenter.hubVal41'), value: 'lv3' }
      ]
    };
  },
  methods: {
    rowClassName({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'first_row';
      }
      return '';
    },
    getHubCodeStyle(rowIndex) {
      if (rowIndex === 0) {
        return {};
      }
      return {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#172033'
      };
    },
    hubLVFn(val) {
      const hl = this.hubLVList.find(item => item.value === val);
      return hl ? hl.label : val;
    }
  }
};
</script>

<style lang="scss" scoped>
.table_class ::v-deep .first_row .tag_class {
  font-weight: bold !important;
  font-size: 15px !important;
  background: transparent !important;
}
.table_class ::v-deep .first_row {
  background-color: #f7f9fb !important;
}
.table_class ::v-deep .first_row .el-table__cell {
  color: #172033 !important;font-weight: bold !important;
}
.table_class ::v-deep .el-table__body-wrapper td .cell div {
  overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 100%;
}
.tag_class { font-size: 13px;font-weight: 600;padding: 5px 8px;border-radius: 15px;box-sizing: border-box; }

.right {
  display: flex;justify-content: flex-end;align-items: center;
}
</style>
